var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDomeCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21123_301468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 7.85264V9.90675C16.25 13.3637 13.45 16.1693 10 16.1693C6.55 16.1693 3.75 13.3637 3.75 9.90675V7.83594",
    stroke: "#CCCFD1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.75C10.5 13.0239 10.2739 13.25 10 13.25C9.72614 13.25 9.5 13.0239 9.5 12.75C9.5 12.4761 9.72614 12.25 10 12.25C10.2739 12.25 10.5 12.4761 10.5 12.75Z",
    stroke: "#CCCFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1579 4.5H2.84211C2.37702 4.5 2 4.8731 2 5.33333V7C2 7.46024 2.37702 7.83333 2.84211 7.83333H17.1579C17.623 7.83333 18 7.46024 18 7V5.33333C18 4.8731 17.623 4.5 17.1579 4.5Z",
    stroke: "#CCCFD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21123_301468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDomeCamera);
export default __webpack_public_path__ + "static/media/icon-dome-camera.99d321eee90d804efd31246d15237c2a.svg";
export { ForwardRef as ReactComponent };